"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromoHeader = require("./PromoHeader");
Object.keys(_PromoHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromoHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromoHeader[key];
    }
  });
});